import { useQuery } from 'react-query';
import { fetchMember } from '@general/api/memberAPI';

const useMemberFromAPI = ({ id }) => {
    const { data, ...rest } = useQuery(
        `member-${id}`,
        async () => {
            const memberData = await fetchMember(id);
            return memberData || null;
        },
        {
            enabled: !!id,
            staleTime: Infinity,
        }
    );

    return { member: data, ...rest };
};

export default useMemberFromAPI;
